import React, { useCallback, useEffect, useRef } from "react"

import classes from "./FoodModalKeypad.module.scss"
import { FaDeleteLeft } from "react-icons/fa6"

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "del"]

const salePriceLimit = 1000000000

const FoodModalKeypad = props => {
  const {
    unit,
    form,
    setForm,
    haveAddOns,
    foodSalePrice,
    focuedInputName
  } = props

  const firstInput = useRef(true)

  const onlyOneDecimalPoint = (key, value) => {
    if (key === "." && value.includes(".")) return false

    return true
  }

  const limitDecimalNumbers = (key, value, limit = 1) => {
    if (key !== "del" && value.split(".")[1]?.length === (limit + 1)) return false

    return true
  }

  const changeDiscount = (key) => {
    if (key === "." && unit === "quantity") return

    if (firstInput.current) {
      firstInput.current = false

      const newDiscount = key !== "del" ? key : "0"

      const reduction =
        Math.round(
          (Number(newDiscount) / 100) * foodSalePrice
        )

      const salePrice =
        Math.round(
          (1 - Number(newDiscount) / 100) * foodSalePrice
        )

      setForm(prev => ({
        ...prev,
        salePrice,
        reduction,
        discount: newDiscount
      }))

      return
    }

    const string = String(form.discount)

    if (string === "0" && key === ".") return

    if (string === "0" && key === "0") return

    if (key === "del") {
      const newDiscount =
        string.length === 1 || string.length === 0 ? 0 :
          string.substring(0, string.length - 1)

      const reduction =
        Math.round(
          (Number(newDiscount) / 100) * foodSalePrice
        )

      const salePrice =
        Math.round(
          (1 - Number(newDiscount) / 100) * foodSalePrice
        )

      setForm(prev => ({
        ...prev,
        salePrice,
        reduction,
        discount: newDiscount
      }))

      return
    }

    if (!onlyOneDecimalPoint(key, string)) return

    const newDiscount =
      string === "0" ? key : (string + key)

    if (!limitDecimalNumbers(key, newDiscount, 2)) return

    if (Number(newDiscount) > 100) return

    const reduction =
      Math.round(
        (Number(newDiscount) / 100) * foodSalePrice
      )

    const salePrice =
      Math.round(
        (1 - Number(newDiscount) / 100) * foodSalePrice
      )

    setForm(prev => ({
      ...prev,
      salePrice,
      reduction,
      discount: newDiscount
    }))
  }

  const changeReduction = (key) => {
    if (key === ".") return

    if (firstInput.current) {
      firstInput.current = false

      const newReduction = key !== "del" ? key : "0"

      const discountDenominator =
        foodSalePrice === 0 ? Infinity : foodSalePrice

      const salePrice =
        Math.round(foodSalePrice - Number(newReduction))

      const discount =
        Math.round(
          (Number(newReduction) / discountDenominator) * 100
        )

      setForm(prev => ({
        ...prev,
        salePrice,
        reduction: newReduction,
        discount
      }))

      return
    }

    const string =
      String(form.reduction) === "0" ? "" : String(form.reduction)

    if (form.reduction === 0 && key === "0") return

    if (key === "del") {
      const newReduction =
        string.length === 1 || string.length === 0 ? 0 :
          string.substring(0, string.length - 1)

      const discountDenominator =
        foodSalePrice === 0 ? Infinity : foodSalePrice

      const salePrice =
        Math.round(
          foodSalePrice - Number(newReduction)
        )

      const discount =
        Math.round(
          (Number(newReduction) / discountDenominator) * 100
        )

      setForm(prev => ({
        ...prev,
        salePrice,
        reduction: newReduction,
        discount
      }))

      return
    }

    const newReduction = string + key

    if (Number(newReduction) > foodSalePrice) return

    const discountDenominator =
      foodSalePrice === 0 ? Infinity : foodSalePrice

    const salePrice =
      Math.round(foodSalePrice - Number(newReduction))

    const discount =
      Math.round(
        (Number(newReduction) / discountDenominator) * 100
      )

    setForm(prev => ({
      ...prev,
      salePrice,
      reduction: newReduction,
      discount
    }))
  }

  const changeSalePrice = (key) => {
    if (key === ".") return

    if (firstInput.current) {
      firstInput.current = false

      const newSalePrice = key !== "del" ? key : "0"

      const discountDenominator =
        foodSalePrice === 0 ? Infinity : foodSalePrice

      const discount =
        Math.round(
          ((foodSalePrice - Number(newSalePrice)) / discountDenominator) * 100
        )

      const reduction =
        Math.round(foodSalePrice - Number(newSalePrice))

      setForm(prev => ({
        ...prev,
        salePrice: newSalePrice,
        reduction,
        discount
      }))

      return
    }

    const string =
      String(form.salePrice) === "0" ? "" : String(form.salePrice)

    if (form.salePrice === 0 && key === "0") return

    if (key === "del") {
      const newSalePrice =
        string.length === 1 || string.length === 0 ? 0 :
          string.substring(0, string.length - 1)

      const discountDenominator =
        foodSalePrice === 0 ? Infinity : foodSalePrice

      const discount =
        Math.round(
          ((foodSalePrice - Number(newSalePrice)) / discountDenominator) * 100
        )

      const reduction =
        Math.round(
          foodSalePrice - Number(newSalePrice)
        )

      setForm(prev => ({
        ...prev,
        salePrice: newSalePrice,
        reduction,
        discount
      }))

      return
    }

    const newSalePrice = string + key

    if (Number(newSalePrice) > salePriceLimit) return

    const discountDenominator =
      foodSalePrice === 0 ? Infinity : foodSalePrice

    const discount =
      Math.round(
        ((foodSalePrice - Number(newSalePrice)) / discountDenominator) * 100
      )

    const reduction =
      Math.round(
        foodSalePrice - Number(newSalePrice)
      )

    setForm(prev => ({
      ...prev,
      salePrice: newSalePrice,
      reduction,
      discount
    }))
  }

  const changeQuanity = (key) => {
    if (haveAddOns) return

    if (key === "." && unit === "quantity") return

    if (form.quantity === "" && key === ".") return

    if (firstInput.current) {
      firstInput.current = false

      setForm(prev => ({
        ...prev,
        quantity: key === "del" ? "" : key
      }))

      return
    }

    if (key === "del") {
      setForm(prev => {
        const qty = String(prev.quantity)

        const newQuantity =
          qty.substring(0, qty.length - 1)

        return {
          ...prev,
          quantity:
            newQuantity === "" ? "" : newQuantity
        }
      })

      return
    }

    if (!onlyOneDecimalPoint(key, form.quantity)) return

    const newQuantity =
      `${form.quantity}${key}`

    if (!limitDecimalNumbers(key, newQuantity, 2)) return

    setForm(prev => ({
      ...prev,
      quantity: newQuantity
    }))
  }

  const handlePress = (key) => {
    switch (focuedInputName) {
      case "quantity":
        changeQuanity(key)
        break
      case "salePrice":
        changeSalePrice(key)
        break
      case "discount":
        changeDiscount(key)
        break
      case "reduction":
        changeReduction(key)
        break
      default: return
    }
  }

  useEffect(() => {
    firstInput.current = true
  }, [focuedInputName])

  const handleKeyPress =
    useCallback((e) => {
      let key = ""

      if (!isNaN(e.key)) {
        key = e.key
      }

      if (e.key === "Backspace") {
        key = "del"
      }

      if (e.key === ".") {
        key = "."
      }

      if (key === "") return

      handlePress(key)
    }, [form, focuedInputName])

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress)

    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [form, focuedInputName])

  return (
    <div className={classes["container"]}>
      {keys.map(key =>
        <button
          key={key}
          className={classes["keyContainer"]}
          onClick={() => handlePress(key)}
        >
          {key === "del" ? <FaDeleteLeft size={20} /> : key}
        </button>
      )}
    </div>
  )
}

export default FoodModalKeypad